import { ChiffrageVersion } from './Version';

export interface ChiffragePhase {
  id: string;
  name: string;
  order: number;
  versions: ChiffrageVersion[];  // vide = phase pas encore démarrée
}

export const DEFAULT_PHASE_NAMES = [
  'Estimation',
  'Avant-projet',
  'Projet',
  'Offre',
  'Marché',
  'Exécution',
];
